import { Button } from "@datapay-by-datacom/design-system";
import { useNavigate } from "react-router-dom";
import { useAuthenticated } from "../../../authn";
import { useProvisionOrg } from "../../hooks";

export function OrgCreatePersonalButton() {
  const authCtx = useAuthenticated();
  const navigate = useNavigate();
  const createPersonalOrg = useProvisionOrg();

  return (
    <Button
      variant="secondary"
      onPress={() =>
        createPersonalOrg.mutate(
          {
            id: authCtx.userId,
            name: "Personal org",
            category: "personal",
            creator_user_id: authCtx.userId,
          },
          {
            onSuccess: () => {
              navigate(`/org/personal/${authCtx.userId}`);
            },
          }
        )
      }
    >
      {createPersonalOrg.isPending
        ? "Creating..."
        : "Create my personal organisation"}
    </Button>
  );
}
